import { z } from 'zod';
/**
 * Việc PM còn phải làm để dự án dùng được hết tính năng — APM-PSET-b.
 *
 * ## Vì sao một chỗ đếm thay vì nhắc rải rác
 *
 * Trước đây mỗi màn hình tự nhắc phần còn thiếu của mình: nút AI nào chưa dùng
 * được thì kèm ba dòng "bạn chưa nhập key AI… hoặc làm thủ công…". Người dùng
 * gặp cùng một câu ở năm chỗ trong lúc đang làm việc khác, và không chỗ nào
 * trả lời được câu họ thật sự cần: **còn bao nhiêu thứ phải cấu hình nữa**.
 *
 * Gom về một con số trên tab Cấu hình đổi câu đó thành đếm được, và mỗi dòng
 * trỏ thẳng tới mục sửa được nó.
 *
 * ## Server trả KHOÁ, không trả câu
 *
 * Nhãn nằm ở i18n (`projectSetup.item.*`) theo quy ước repo: chuỗi hiển thị
 * không đi qua API. Thêm một mục nghĩa là thêm một khoá — và `project-setup`
 * có test canh mọi khoá đều có nhãn ở cả hai ngôn ngữ.
 *
 * ## ⚠️ Chỉ chứa việc người ĐANG XEM làm được
 *
 * Mỗi mục đòi đúng quyền mà mục cấu hình phía sau nó đòi. Đếm cả những thứ một
 * CONTRIBUTOR không sửa nổi thì badge đỏ thành một lời trách không có đường
 * giải quyết — họ thấy "3 việc cần làm" và không bấm được vào đâu.
 */
export const ProjectSetupItemKey = z.enum(['taskTypes', 'aiKey', 'members', 'rates']);
export const ProjectSetupItem = z.object({
    key: ProjectSetupItemKey,
    /** `id` của mục trong tab Cấu hình — dùng cho `?tab=settings&section=…`. */
    section: z.string(),
});
export const ProjectSetupStatus = z.object({
    projectId: z.uuid(),
    items: z.array(ProjectSetupItem),
});
/** Mục Cấu hình sửa được từng việc — một chỗ khai, dùng ở cả hai phía. */
export const PROJECT_SETUP_SECTION = {
    taskTypes: 'task-types',
    aiKey: 'ai-key',
    members: 'members',
    rates: 'staffing-rates',
};
//# sourceMappingURL=project-setup.js.map